module.exports = __webpack_public_path__ + "static/media/keterampilan.bfbf4bd7.jpeg";